import React, { useCallback, useEffect } from 'react';

import Button from '@ott/button';
import { l10n, l10nhtml } from '@ott/l10n';
import Modal, { CONTENT_SIZE } from '@ott/modal';

import BackgroundGradient from '../../../BackgroundGradient';
import CardImage from '../../../CardImage';
import { useKM } from '../../hooks/useKM';

import styles from './ReleasePromoModal.scss';

const MODAL_CONTENT_OPTIONS = {
  size: CONTENT_SIZE.SMALL,
  className: styles.content,
};

type Props = {
  onClose: VoidFunction;
  onAction: VoidFunction;
  preventUserCloseModal?: boolean;
  onShowPromoModal: VoidFunction;
};

const ReleasePromoModal = (props: Props) => {
  const { preventUserCloseModal, onClose, onAction, onShowPromoModal } = props;
  const { sendKM } = useKM();

  useEffect(() => {
    sendKM('Virtual_Card_Features_No_UPRID_transition');
    onShowPromoModal();
  }, []);

  const handleClickAgreements = useCallback(() => {
    sendKM('Virtual_Card_Info_Popup');
  }, []);

  const handleClose = useCallback(() => {
    sendKM('Virtual_Card_Issued_Success_Close_No_Uprid_Press');
    onClose();
  }, [onClose]);

  return (
    <Modal
      isOpen={true}
      fullScreenOnMobile={true}
      contentOptions={MODAL_CONTENT_OPTIONS}
      preventUserClose={preventUserCloseModal}
      onClose={handleClose}
    >
      <BackgroundGradient />
      <div
        className={styles.wrapper}
        id="virtual-card-release-promo"
        data-locator="virtual-card-release-promo"
      >
        <div className={styles.card}>
          <CardImage />
        </div>
        <div className={styles.title}>{l10n('virtualCard.releasePromo.title')}</div>
        <div className={styles.options}>
          <p className={styles.optionTitle}>
            {l10n('virtualCard.releasePromo.options.cashbackValue')}
          </p>
          <p className={styles.optionText}>
            {l10n('virtualCard.releasePromo.options.cashbackText')}
          </p>
          <p className={styles.optionTitle}>
            {l10n('virtualCard.releasePromo.options.speedValue')}
          </p>
          <p className={styles.optionText}>{l10n('virtualCard.releasePromo.options.speedText')}</p>
          <p className={styles.optionTitle}>
            {l10n('virtualCard.releasePromo.options.priceValue')}
          </p>
          <p className={styles.optionText}>{l10n('virtualCard.releasePromo.options.priceText')}</p>
        </div>
        <div className={styles.agreements} onClick={handleClickAgreements}>
          {l10nhtml('virtualCard.releasePromo.agreements')}
        </div>
        <div className={styles.button}>
          <Button
            onClick={onAction}
            withFullWidth={true}
            specificLocators="virtual-card-release-button"
          >
            {l10n('virtualCard.releasePromo.action')}
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default ReleasePromoModal;
